import type { Resource } from 'i18next';

export enum LangEnum {
  EN = 'en',
}

export type LangResources = Record<LangEnum, { translation: Resource }>;
